<!--<div class="pointer" data-toggle="collapse" [attr.data-target]="'#collapse-' + nro" aria-expanded="false"
  aria-controls="collapseContent">-->
<div class="pointer" aria-expanded="false">
  <div class="card mb-2"
    style="border-radius: 40px; background: linear-gradient(180deg, rgba(113, 90, 251, 0.2) 0%, rgba(125, 100, 236, 0.13) 100%);">
    <div class="card-body">
      <div class="row" style="height: 7rem;">
        <div class="col-12 d-flex justify-content-center">
          <img src="{{img}}" class="img-fluid" alt="">
        </div>
      </div>
    </div>
  </div>
  <h5 id="titleCard" class="user-select-none font-brand text-uppercase mb-5 text-center text-white">{{title}}</h5>
</div>

<div class="row">
  <div class="col-12">
    <div class="collapse" [id]="'collapse-' + nro">
      <div class="mt-3">
        <h6 class="font-brand-secondary text-brand text-uppercase" style="font-size: 24px;">{{header}}</h6>

        <ul class="list-unstyled mt-2" style="list-style:none;">
          <li *ngFor="let item of topics" class="mb-2">
            <h5 class="font-brand-secondary text-white text-uppercase mt-2" style="font-size: 18px;">
              <span class="font-brand text-brand text-uppercase">/</span>{{item}}
            </h5>
          </li>
        </ul>

      </div>
    </div>
  </div>
</div>